/** @type {import('tailwindcss').Config} */
module.exports = {
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    theme: {
        extend: {
            fontFamily: {
                primary: ['Poppins', 'sans-serif'],
            },
            colors: {
                gray: '#F1F1F1',
                heavyBleeding: '#A24874',
                lightBleeding: '#D57D97',
                spotting: '#F4B0C5',
                moreFertile: '#8CBCD8',
                lessFertile: '#9FCDE8',
                notFertile: '#D8D4E5',
                purple: '#7E6FA8',
            },
        },
    },
    daisyui: {
        themes: [
            {
                peakday: {
                    primary: '#54214D',
                    'primary-content': '#FFFFFF',
                    secondary: '#FFFFFF',
                    'secondary-content': '#FFFFFF',
                    accent: '#56FFFC',
                    neutral: '#CCCCCC',
                    'base-100': '#EEEEEE',
                    'base-content': '#C3C0C0',
                    '--rounded-btn': '9999px',
                    '--btn-text-case': 'uppercase',
                    '--btn-focus-scale': '.97',
                },
            },
        ],
    },
    plugins: [require('daisyui')],
};
